// import React from 'react';
import swal from 'sweetalert';
import ApiUrl from "./apiUrl";

async function handleErrors(response) {
	if (response.status !== 200 && response.status !== 400) {
		if (response.status === 401) {
			swal('Unauthorized!', 'Please login again', 'error');
			localStorage.removeItem('surya-service-token');
			localStorage.removeItem('sury-service-user');
			localStorage.removeItem('surya-service-companyID');
			localStorage.removeItem('surya-service-role');
			window.location.href = "/login";
		} else {
			const parsed = await response.json();
			swal('Internal Server Error!', parsed.error, 'error');
			console.log(parsed.message);
		}

		throw Error(response.statusText);
	}
	return response;
}
function Api() {

	const Login = (token, companyID, role, name, perms = {}) => {
		localStorage.setItem('surya-service-token', token);
		localStorage.setItem('sury-service-user', name);
		localStorage.setItem('surya-service-companyID', companyID);
		localStorage.setItem('surya-service-role', role);
		localStorage.setItem('surya-service-canview', perms.canViewUser ? 'true' : 'false');
		localStorage.setItem('surya-service-canadd', perms.canAddUser ? 'true' : 'false');
		localStorage.setItem('surya-service-canedit', perms.canEditUser ? 'true' : 'false');
		localStorage.setItem('surya-service-candelete', perms.canDeleteUser ? 'true' : 'false');
	}

	const LogOut = () => {
		localStorage.removeItem('surya-service-token');
		localStorage.removeItem('sury-service-user');
		localStorage.removeItem('surya-service-companyID');
		localStorage.removeItem('surya-service-role');
		localStorage.removeItem('surya-service-canview');
		localStorage.removeItem('surya-service-canadd');
		localStorage.removeItem('surya-service-canedit');
		localStorage.removeItem('surya-service-candelete');
	}

	const isAuthenticated = () => {
		return localStorage.getItem('surya-service-token');
	};

	const getUser = () => {
		return localStorage.getItem('sury-service-user');
	};

	const getRole = () => {
		return localStorage.getItem('surya-service-role');
	};

	const isServicePerson = () => {		
		return +getRole() === 3 ? true : false
	}

	const isOwner = () => +getRole() === 1;

	const isHr = () => +getRole() === 5;

	// Roles allowed to add/edit/delete users: Owner(1), Sr. Manager(4), HR(5).
	const canManageUsers = () => [1, 4, 5].includes(+getRole());

	// Owner manages anyone; Sr. Manager / HR manage only Manager(2) & Engineer(3).
	const canManageTargetRole = (targetRole) =>
		isOwner() || (canManageUsers() && [2, 3].includes(+targetRole));

	// Role-based user managers (Owner / Sr. Manager / HR) may also GRANT user permissions.
	const isRoleBasedManager = () => [1, 4, 5].includes(+getRole());

	// Per-user permission flags (stored at login). Role-based managers always have them.
	const canViewUser = () => isRoleBasedManager() || localStorage.getItem('surya-service-canview') === 'true';
	const canAddUser = () => isRoleBasedManager() || localStorage.getItem('surya-service-canadd') === 'true';
	const canEditUser = () => isRoleBasedManager() || localStorage.getItem('surya-service-canedit') === 'true';
	const canDeleteUser = () => isRoleBasedManager() || localStorage.getItem('surya-service-candelete') === 'true';

	// Whether the current user may edit/delete a user of the given role (Owner: anyone; others: Manager/Engineer).
	const canEditTarget = (targetRole) => isOwner() || (canEditUser() && [2, 3].includes(+targetRole));
	const canDeleteTarget = (targetRole) => isOwner() || (canDeleteUser() && [2, 3].includes(+targetRole));

	const getCompany = () => localStorage.getItem('surya-service-companyID');

	const doFetch = async (type, data, url) => {
		let reqData = { ...data };
		const token = localStorage.getItem("surya-service-token");
		if (data === null || data === undefined) { reqData = {}; }
		return fetch(url, {
			method: type,
			headers: type !== 'GET' && type !== 'DELETE' ? {
				'Authorization': `Bearer ${token}`,
				'content-type': 'Application/json'
			}
				: {
					'Authorization': `Bearer ${token}`,
				},
			body: type !== 'GET' && type !== 'DELETE' ? JSON.stringify({ ...reqData }) : null,
		})
			.then(handleErrors)
			.then(res => res.json())
			.catch(err => console.log(err));
	};

	const doUpload = async (type, data, url) => {
		const token = localStorage.getItem("surya-service-token");

		return fetch(url, {
			method: type,
			headers: {
				'Authorization': `Bearer ${token}`,
			},
			body: data,
		})
			.then(handleErrors)
			.then(res => res.json())
			.catch(err => console.log(err));
	};
	return {
		doFetch,
		Login,
		doUpload,
		LogOut,
		isAuthenticated,
		getUser,
		getCompany,
		getRole,
		isServicePerson,
		isOwner,
		isHr,
		canManageUsers,
		canManageTargetRole,
		isRoleBasedManager,
		canViewUser,
		canAddUser,
		canEditUser,
		canDeleteUser,
		canEditTarget,
		canDeleteTarget
	};
}
export default new Api();